@if (!profileswitchselected) {
<div class="group-section">
  <span class="operate">{{ 'BP_PM_OPERATING_AS' | translate}}</span>
  <div class="profile">
    <span class="dp">
      <img [src]="profileImage" alt="">
    </span>
    <div>
      <p>{{ groupName}}</p>
      <span (click)="switchProfile($event)" role="button">{{'BP_PM_SWITCH_PROFILE' | translate}}</span>
    </div>
  </div>
  <ul>
    @if (enableManageBusiness) {
    <li (click)="manageBusiness()" role="button">
      <span class="manage-business">{{'BP_PM_MANAGE_BUSINESS' | translate}}</span>
    </li>
    }
    @if (enableManageFleet) {
    <li role="button" (click)="myFleets()">
      <span class="manage-feet">{{'BP_PM_MANAGE_FLEET' | translate}}</span>
    </li>
    }
    @if (enableContentModeration && isModerationEnabled) {
    <li role="button" (click)="contentModeration()">
      <span class="content-moderation">{{'BP_CTM_CONTENT_MODERATION' | translate}}</span>
    </li>
    }
  </ul>
</div>
}

@if (profileswitchselected) {
<app-alias-list [isSwitchProfile]="true"></app-alias-list>
}